import { render } from "./theme152.vue?vue&type=template&id=320015a2&scoped=true"
import script from "./theme152.vue?vue&type=script&lang=js"
export * from "./theme152.vue?vue&type=script&lang=js"

import "./theme152.vue?vue&type=style&index=0&id=320015a2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-320015a2"

export default script